export default __webpack_public_path__ + "static/media/white.ed56ce49.jpg";